import './ToggleGroup.css';

export default function ToggleGroup({
  label,
  options,
  value,
  onChange,
  className = ''
}) {
  return (
    <div className={`toggle-group ${className}`}>
      {label && <label className="toggle-group__label">{label}</label>}
      <div className="toggle-group__options" role="radiogroup">
        {options.map((option) => (
          <button
            key={option.value}
            type="button"
            role="radio"
            aria-checked={value === option.value}
            className={`toggle-group__option ${value === option.value ? 'toggle-group__option--active' : ''}`}
            onClick={() => onChange?.(option.value)}
          >
            {option.icon && <span className="toggle-group__icon">{option.icon}</span>}
            <span className="toggle-group__text">{option.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
